<template>
  <v-card
    @click="gotoRoute(url)"
    class="mx-auto"
    max-width="550"
    min-height="150"
    :color="backgroundColor"
    hover
  >
    <v-img
      :src="imgUrl ? imgUrl : '/img/menus/catalogos/actividades.jpg'"
      class="white--text align-end"
      :gradient="getGradient(backgroundColor)"
      max-height="250"
    >
      <v-card-title v-text="title"></v-card-title>
    </v-img>
  </v-card>
</template>

<script>
export default {
  name: "myMenuCard",
  props: {
    title: String,
    description: String,
    icon: String,
    url: String,
    imgUrl: String,
    backgroundColor: String,
  },
  data: function () {
    return {
      availableColors: {
        primary: "to bottom, rgba(0,139,0,.30), rgba(14,80,14,.66)",
        pla_c3: "to bottom, rgba(133,140,0,.30), rgba(80,80,14,.66)",
        support: "to bottom, rgba(121,121,118,.40), rgba(50,50,51,.86)",
        secondary: "to top, rgba(4, 68, 85, 0.9), rgba(4, 68, 85, .40)",
      },
    };
  },
  methods: {
    gotoRoute(url) {
      if (url) {
        this.$router.push({ name: url });
      }
    },
    getGradient(backgroundColor) {
      let gradient = this.availableColors[backgroundColor];
      if (!gradient) {
        return "to bottom, rgba(121,121,118,.40), rgba(50,50,51,.86)";
      }
      return gradient;
    },
  },
};
</script>

<style scoped></style>
